import {
  Partners,
  QUOTE_TYPES,
  QUOTE_WORKFLOW_STATUSES,
  QuoteType,
  QuoteWorkflowStatus,
} from '@lockton-apps/shared/interfaces';
import { createDefinition } from '@lockton-apps/shared/util/helpers';
import { WorkflowStatusMeta } from './interface';

const getPaymentWorkflowMeta2 = createDefinition<WorkflowStatusMeta>({
  base: {
    label: $localize`Pending`,
    icon: 'more',
    level: 'info',
  },
  variants: {
    [QUOTE_WORKFLOW_STATUSES.AwaitingPayment]: {
      base: {
        label: $localize`Awaiting payment`,
        icon: 'invoice_sent_universal_thin',
        level: 'info',
      },
      variants: {
        [QUOTE_TYPES.Renewal]: {
          base: {},
          variants: {
            [Partners.LSOS_ADDON]: {
              base: {
                icon: 'invoice_unpaid_universal_thin',
              },
            },
          },
        },
      },
    },
    [QUOTE_WORKFLOW_STATUSES.PaymentProcessing]: {
      base: {
        label: $localize`Payment processing`,
        icon: 'payment_progress',
        level: 'info',
      },
    },
    [QUOTE_WORKFLOW_STATUSES.PaymentReceived]: {
      base: {
        label: $localize`Payment received`,
        icon: 'invoice_paid_universal_thin',
        level: 'info',
      },
    },
    [QUOTE_WORKFLOW_STATUSES.PolicyDocumentationSent]: {
      base: {
        label: $localize`Policy documentation sent`,
        icon: 'doc_sent_thin',
        level: 'info',
      },
      variants: {
        [QUOTE_TYPES.NewBusiness]: {
          base: {},
          variants: {
            [Partners.NORWAY_PI]: {
              base: {
                label: $localize`Complete`,
                icon: 'tick_thin',
              },
            },
          },
        },
        [QUOTE_TYPES.Renewal]: {
          base: {},
          variants: {
            [Partners.NORWAY_PI]: {
              base: {
                label: $localize`Complete`,
                icon: 'tick_thin',
              },
            },
            [Partners.LSOS]: {
              base: {
                label: $localize`Awaiting Payment`,
                icon: 'payment_progress',
              },
            },
            [Partners.LSOS_ADDON]: {
              base: {
                label: $localize`Completed`,
                icon: 'tick_thin',
              },
            },
          },
        },
      },
    },
    [QUOTE_WORKFLOW_STATUSES.NotTakenUp]: {
      base: {
        label: $localize`Not taken up`,
        icon: 'renewal_ntu_thin',
        level: 'info',
      },
    },
  },
});

export function getPaymentWorkflowMeta(
  status: QuoteWorkflowStatus,
  quoteType: QuoteType,
  partner: Partners | 'DEFAULT' = 'DEFAULT'
) {
  return getPaymentWorkflowMeta2([status, quoteType, partner]);
}
